import { AddressModel } from "./City";

export enum PaymentStatus {
  PENDING = "pending",
  CANCELED = "canceled",
  PAID = "paid",
  FAILED = "failed",
  NOT_REQUIRED = "not_required",
}

export interface OrderResponse {
  _id: string;
  pickUpAddress?: AddressModel;
  deliveryAddress?: AddressModel;
  totalDistance?: string;
  subTotal?: number;
  totalWeight?: string;
  hst?: number;
  /** Tax from Shopify (or other platform) on the shopper order. */
  platformTax?: number;
  platformTaxLabel?: string;
  platformTaxLines?: Array<{
    title: string;
    rate?: number | null;
    price: number;
  }>;
  paymentStatus?: PaymentStatus;
  orderStatus?: string;
  deliveryOption?: string;
  deliveryPin?:string;
  driverName?:string;
  totalFare?: number;
  totalItems?: string;
  packageReadyTime: Date;
  deliveryTime?: Date;
  vehicleType?: string;
  userId?: string;
  uniqueId?: string;
  orderType?: "order" | "draft";
  submissionStatus?: "confirmed" | "payment_required";
  clientSubmissionId?: string;
  notes?: string;
  sizeDescription?:string;
  description?: string;
  settingsType?: string;
  deliveryServiceName?: string;
  createdAt?: string;
  sentBy?: string;
  activeSeconds?: number;
  driverNoteAddress?: string;
  statusDetails?: {
    date?: string;
    notes: string;
    receiverName: string;
    shipperName: string;
    signature: string;
    status: string;
    time: string;
    image: string;
    imageData: string;
    deliveredDetails?: {
      nameOfReciever?: string;
      deliveredDate?: string;
      deliveredTime?: string;
      deliverSignature?: string;
    };
  };
  appliedPromo?:{
     discountPercent:number
  }
}
